import { Organization } from '@marmon/shared/types/organization';
import { Group } from '../interfaces';

/**
 * Resolves the organizations that belong to a group from a lookup map,
 * skipping missing and soft-deleted organizations.
 */
export function organizationsForGroup(
	group: Group,
	organizationsById: Map<string, Organization>,
): Organization[] {
	return (group.organizations ?? [])
		.map((ref) => organizationsById.get(ref.id))
		.filter((org): org is Organization => !!org && org.deletedAt == null);
}
